/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import componentFactory from '../componentFactory';
import componentPropTypes from './abstractComponentPropTypes';
import serviceFactory from '../../services/serviceFactory';
import engineConstants from '../engineConstants';

const propDefinitions = {
    isFocused: componentPropTypes.isFocused,
    isReadMode: componentPropTypes.isReadMode,
    onValueChanged: componentPropTypes.onValueChanged,
    style: componentPropTypes.style,
    tipText: componentPropTypes.tipText,
    value: componentPropTypes.value,
    xStyle: componentPropTypes.xStyle,
    propertyRef: componentPropTypes.propertyRef,
};

export default class Radio extends Component {
    static propTypes = propDefinitions;
    static typeName = engineConstants.component.name.radio;

    render() {
        const {
            isFocused,
            isReadMode,
            onValueChanged,
            propertyRef,
            style,
            tipText,
            value,
            xStyle,
        } = this.props;
        const { lang: { generic: { yes, no } } } = serviceFactory;
        const { booleanFalseAlias, booleanTrueAlias } = xStyle;
        const items = [
            { label: booleanTrueAlias || yes, value: true },
            { label: booleanFalseAlias || no, value: false },
        ];
        const radioProps = {
            isFocused,
            isReadMode,
            onValueChanged,
            propertyRef,
            style,
            tipText,
            value: isReadMode ? value === (booleanTrueAlias || yes) : value === 'true',
            xStyle,
            items,
        };
        return React.createElement(componentFactory.getPlatformPropertyComponent('radio'), { ...radioProps });
    }
}
